define(function (require) {
    "use strict";

    var Marionette = require("marionette");
    var template = require("ui/dropdown-menu/templates/dropdownMenuItem.tmpl");

    var DropdownMenuItemView = Marionette.ItemView.extend({
        template : template,
        className : "menu-item",
        tagName : "li",
        events: {
            "click": "triggerChangeSelection"
        },
        modelEvents: {
            'change:enabled': 'toggleEnabled',
            'change:title': 'updateTitle'
        },

        ui : {
            liAction : ".li-action"
        },

        /**
         * Add some attributes after the li  HTML element rendered.
         */
        onRender : function () {
            if (this.model.get("icon") !== ""){
                this.$el.addClass("withIcon");
            }
            this.toggleEnabled();
            this._setTooltip();
        },

        _setTooltip: function(){
            if (this.model.get("title") !== ""){
                this.$el.attr("title", this.model.get("title"));
            }
            if (this.model.get("align") !== ""){
                this.$el.attr("tooltip-align", this.model.get("align"));
            }
        },

        toggleEnabled: function(){
            this.$el.toggleClass('disabled', this.model.get('enabled') === false);

        },

        updateTitle: function(title) {
            this.$el.attr("title", this.model.get("title"));
            this.ui.liAction.attr("title", this.model.get("title"));

            // tooltip-text (following line) is a patch for an exception in which the tooltip is kept opened while modification is done
            this.ui.liAction.attr("tooltip-text", this.model.get("title"));
            this.$el.attr("tooltip-text", this.model.get("title"));
        },

        triggerChangeSelection: function(){
            this.trigger('changeSelection', this);
        },

        /**
         * triggered when the view is close
         */
        onClose : function () {
            // Custom cleanup or closing code
            if (this.ui.liAction) {
                this.ui.liAction.empty();
                this.ui.liAction.remove();
            }
            this.model.off("change:enabled");
        }
    });

    return DropdownMenuItemView;
});
